import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '@/store'
import en from '@/lang/en'
import zh from '@/lang/zh'
import { toTraditional } from './langConvert'

Vue.use(VueI18n)

// 从本地存储获取初始语言，避免依赖Vuex初始化顺序
const initialLocale = localStorage.getItem('locale') || 'zh-TW'

// 创建 i18n 实例
const i18n = new VueI18n({
  locale: initialLocale,
  fallbackLocale: 'zh-TW',
  messages: {
    'zh-CN': zh, // 简体中文
    'zh-TW': zh, // 繁体中文（使用简体包，后续动态转换）
    'en': en // 英文
  }
})

// 保存原始的 $t 方法，避免递归调用
const originalT = Vue.prototype.$t

// 自定义翻译函数：支持动态简繁转换
Vue.prototype.$t = function (key, ...args) {
  const locale = store.getters['language/currentLocale']

  // 调用原始的 $t 方法获取翻译结果
  const message = originalT.call(this, key, ...args)

  // 如果是繁体，进行动态转换
  if (locale === 'zh-TW') {
    return toTraditional(message)
  }

  return message
}

// 监听 Vuex 语言变化并同步更新 i18n
store.watch(
  (state) => state.language.locale,
  (newLocale) => {
    // 仅在语言确实变化时才更新，避免不必要的渲染
    if (i18n.locale !== newLocale) {
      i18n.locale = newLocale
    }
  }
)

export default i18n



// WEBPACK FOOTER //
// ./src/plugins/i18n.js